import React, { useState } from "react";
import ToolTipUI from "../../../../../stories/core-components/ToolTip/ToolTipUI";
import PriceDetailsTooltipUI from "../PriceDetailsTooltip/PriceDetailsTooltipUI";
import * as S from "./PaymentComponent.styles";
import { gcBookingReviewScreen, pushCtaOmniEvents } from "../../../../../shared/config/omni";
import { CTA_TYPE, getActionNameForOmniture } from "../../../../../shared/utils/omni-utils";
import { CABS_REVIEW_ROUTE, FULL_PAYMENT, PARTIAL_PAYMENT, PAYMENT_COMPONENT, PERSUASION_DETAILS, VIEW_PAYMENT_INFO } from "../../../../../shared/utils/util-constants";
interface IGoCash {
  Total: number;
}
interface IPaymentOptions {
  amount_with_gc: number
  amount_without_gc: number
  is_selected: boolean
  pay_text: string
  percentage: string
  st: string
  t: string,
  amount: number
}

interface IPayment {
  Full: IPaymentOptions;
  Partial: IPaymentOptions;
  fare_details: Array<{}>;
  callPayment: Function;
  is_part_payment: boolean;
  updateSelectedData: Function;
  additional_info_message: string;
  price_pers: string;
  tool_tip: string;
  apply_gocash: boolean;
  Order: IGoCash;
}

const PaymentComponent: React.FC<IPayment> = ({
  Full = null,
  Partial = null,
  fare_details = [],
  callPayment,
  updateSelectedData,
  is_part_payment = false,
  price_pers = "",
  tool_tip = "",
  apply_gocash = false,
  Order = {}
}) => {
  const [tooltip, setTooltip] = useState(false);
  const [tooltip1, setToolTip1] = useState(false);
  const { Total = 0 } = Order;
  let priceDetails = !is_part_payment ? Full : Partial;
  let payTxt = priceDetails?.pay_text || '';
  if (payTxt) {
    const str = !is_part_payment ? '<fa>' : '<pa>';
    payTxt = payTxt.replace(
      str,
      `₹${priceDetails?.amount}`
    );
  }

  const updatePayment = (flag) => {
    pushCtaOmniEvents(getActionNameForOmniture(gcBookingReviewScreen, !flag ? PARTIAL_PAYMENT : FULL_PAYMENT), CTA_TYPE.RADIO_BUTTON, PAYMENT_COMPONENT, CABS_REVIEW_ROUTE)
    updateSelectedData({ is_part_payment: !flag });
  };

  return (
    <S.PaymentComponentWrap>
      <div className="pymntCmp_hdng">
        <div className="makeFlex column">
          <span className="font22 lineHeight28 rubik fontMedium">
            Total Amount
          </span>
          <span className="font12 lightGrey">Inclusive of GST</span>
        </div>
        <div className="makeFlex column">
          <span className="font22 lineHeight28 rubik fontMedium txtRight">
            <span className="giRupee">₹</span>
            {Full?.amount}
          </span>
          <div className="viewDtl">
            <a
              className="font14Global"
              onMouseOver={() => {
                pushCtaOmniEvents(getActionNameForOmniture(gcBookingReviewScreen, VIEW_PAYMENT_INFO), CTA_TYPE.HYPER_LINK, PAYMENT_COMPONENT, CABS_REVIEW_ROUTE)
                setTooltip(true)
              }}
              onMouseOut={() => setTooltip(false)}
            >
              View details
            </a>
            {tooltip && <PriceDetailsTooltipUI fare_details={fare_details} apply_gocash={apply_gocash} amount={Total} />}
          </div>
        </div>
      </div>
      {Full && Partial && <div className="pymntCmp_mode">
        <S.Radiobox
          className={!is_part_payment ? "" : "active"}
          onChange={() => updatePayment(false)}
        >
          <input
            type="radio"
            name="paymentNow"
            id="partPymnt"
            checked={is_part_payment}
          />
          <label htmlFor="partPymnt" className="makeFlex spaceBetween">
            <span className="makeFlex column">
              <span className="font16 fontMedium">
                {Partial?.t?.replace(
                  "<pa>",
                  `₹${Partial?.amount}`
                )}
              </span>
              <span className="lightGrey font14">{Partial?.st}</span>
            </span>
            {/* <span className="font16 fontMedium fr">{}</span> */}
          </label>
        </S.Radiobox>
        <S.Radiobox
          className={!is_part_payment ? "active" : ""}
          onChange={() => updatePayment(true)}
        >
          <input
            type="radio"
            name="paymentNow"
            id="fullPymnt"
            checked={!is_part_payment}
          />
          <label htmlFor="fullPymnt" className="makeFlex spaceBetween">
            <span className="makeFlex column">
              <span className="font16 fontMedium">
                {Full?.t?.replace(
                  "<fa>",
                  `₹${Full?.amount}`
                )}
              </span>
              <span className="lightGrey font14">{Full?.st}</span>
            </span>
          </label>
        </S.Radiobox>
      </div>}
      <div className="pymntCmp_btm">
        <S.BookNowBtn id="paymentButton" onClick={callPayment}>{payTxt}</S.BookNowBtn>
        {price_pers ? (
          <p className="font12 textCenter appendTop12">
            <span
              className="greenText"
              dangerouslySetInnerHTML={{ __html: price_pers }}
            ></span>
            <a className="fontMedium"
              style={{ position: "relative" }}
              onMouseOver={() => {
                pushCtaOmniEvents(getActionNameForOmniture(gcBookingReviewScreen, PERSUASION_DETAILS), CTA_TYPE.HYPER_LINK, PAYMENT_COMPONENT, CABS_REVIEW_ROUTE)
                setToolTip1(true)
              }}
              onMouseOut={() => setToolTip1(false)}> Know more</a>
              <div style={{ position: "absolute", marginTop: '-17px' }}>
              {tooltip1 && tool_tip ? <ToolTipUI title={""} data={tool_tip} showIcon={false} /> : null}
              </div>
          </p>
        ) : null}
      </div>
    </S.PaymentComponentWrap>
  );
};

export default React.memo(PaymentComponent);
